export enum MailSystemType {
  MICROSOFT_365 = 'microsoft-365',
  GOOGLE_WORKSPACE = 'google-workspace',
  THIRD_PARTY_GATEWAY = 'third-party-gateway',
}

export interface MailSystemDetectionResult {
  domains: string[];
  mailSystem: MailSystemType | null;
  mxRecords?: string[];
  error?: string;
  detectedAt: string;
}
